
import { mapState } from 'vuex'

import SavedAddress from '../SavedAddress'

export default {
  name: 'SavedAddresses',
  components: {
    SavedAddress
  },
  computed: {
    ...mapState([ 'user', 'appInfo' ]),
    ...mapState({
      addresses: state => state.members.addresses,
    }),
    canRemoveAddress() {
      return this.appInfo?.location?.removeSavedAddress ? true : false
    }
  },
}
